<template>
    <BasePanel
        headline='lang_GENERIC_AZ_PANEL_CAPTION_METADATA'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <v-col cols="4">
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Language"
                            :items="dropdownLanguages" 
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-language'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="FoundingDate"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOUNDING_DATE')"
                            :alvqa="alvqa + '-datepicker-founding-date'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="CustomerNumber"
                            :label="$t('lang_GENERIC_AZ_CAPTION_CUSTOMER_NUMBER')"
                            :alvqa="alvqa + '-textfield-customer-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Currency"
                            :items="dropdownCurrency" 
                            :clearable="false"
                            :label="$t('lang_GENERIC_CAPTION_CURRENCY')"
                            :alvqa="alvqa + '-dropdown-invoice-currency'"
                        /> 
                    </v-row> 
                </v-col>

                <v-col cols="4">
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="TasFromPricelist"
                            :items="dropdownYesNo" 
                            :label="$t('lang_AZ_GROUPS_CAPTION_TAS_FROM_PRICELIST')"
                            :alvqa="alvqa + '-dropdown-tas-from-pricelist'"
                        /> 
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="WarehouseName"
                            :label="$t('lang_AZ_GROUPS_CAPTION_WAREHOUSE_NAME')"
                            :alvqa="alvqa + '-textfield-warehouse-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FocFirstShipment"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_FIRST_SHIPMENT')"
                            :alvqa="alvqa + '-textfield-foc-first-shipment'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FocAllShipments"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_ALL_SHIPMENTS')"
                            :alvqa="alvqa + '-textfield-foc-all-shipments'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="HandlingFee"
                            :label="$t('lang_AZ_GROUPS_CAPTION_HANDLING_FEE')"
                            :alvqa="alvqa + '-textfield-handling-fee'"
                        />
                    </v-row>
                </v-col>

                <v-col cols="4">
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="DistributorReturnFee"
                            :label="$t('lang_AZ_DISTRIBUTORS_FEE_FOR_RETURNS')"
                            :alvqa="alvqa + '-textfield-distributor-return-fee'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="ReturnReserveCycle"
                            :items="dropdownReturnReserveCycle" 
                            :label="$t('lang_AZ_DISTRIBUTORS_CYCLE_OF_RETURN_RESERVE')"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-return-reserve-cycle'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="ReturnReservePercent"
                            :label="$t('lang_AZ_DISTRIBUTORS_CAPTION_RETURNS_RESERVE_PERCENT')"
                            :alvqa="alvqa + '-textfield-return-reserve-percent'"
                            suffix="%"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'

import 
    { 
        DropdownErpInvoicesLanguages, 
        DropdownGenericYesNo,
        DropdownCurrencies,
        DropdownContractsLabelReturnReserveCycle
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzDistributorsMetadataEditPanel",
    components: {
        BasePanel,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageDatePicker,
    },
    data() {
        return {
            context: "AzDistributorsMetadata",
            alvqa: "az-distributors-edit-form-panel-metadata"
        }
    },
    computed: {
        dropdownLanguages()     { return DropdownErpInvoicesLanguages },
        dropdownYesNo()         { return DropdownGenericYesNo },
        dropdownCurrency()      { return DropdownCurrencies },
        dropdownReturnReserveCycle() { return DropdownContractsLabelReturnReserveCycle }
    }
}
</script>